import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { environment } from '@mri-platform/shared/core';
import { defineCustomElements } from '@mri/ask-agora-intelligence/loader';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

// Register ask-agora-intelligence custom elements (e.g. ask-ai) before Angular bootstraps.
// This ensures ask-agora-intelligence claims the ask-ai tag BEFORE the ag-widget CDN
// bundle loads, preventing the "Constructor for ask-ai#undefined" Stencil namespace clash.
defineCustomElements();

if (environment.production) {
  enableProdMode();
} else if (environment.dev) {
  // make rxjs-spy library available in dev tools
  // for more information see: https://github.com/cartant/rxjs-spy
  import('rxjs-spy').then(rxjsSpy => {
    console.log(
      '[rxjsSpy] Added to window. To enable logging of tagged observables, at the console window type: `rxjsSpy.create(); spy.log()`'
    );
    console.log('[rxjsSpy] For more information see: https://github.com/cartant/rxjs-spy');
    Object.assign(window, { rxjsSpy });

    // to start observing observables that emit during the initial route navigation uncomment the following code:
    // const spy = rxjsSpy.create();
    // spy.log(/MainNavBarComponent/); // <- example of using a regex pattern to match on specific tag names
  });
}

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
